import styled from 'styled-components';
import { Snackbar as MuiSnackbar } from '@material-ui/core';

const Snackbar = styled(MuiSnackbar)`
  left: 50%;
  bottom: 5rem;
  min-width: 212px;
  transform: translateX(-50%);
  .MuiSnackbarContent-root {
    display: flex;
    justify-content: center;
    min-width: 280px;
    padding: 0;
    color: ${({ theme }) => theme.palette.grey[300]};
    background-color: ${({ theme }) => theme.palette.grey[900]};
    font-size: ${({ theme }) => theme.typography.pxToRem(14)};
    line-height: 1.53;
    box-shadow: none;
  }
  .MuiSnackbarContent-message {
    padding: 14px 16px;
    line-height: 1.43;
    text-align: center;
  }
`;

export default Snackbar;
